// extracted by mini-css-extract-plugin
export var cardTitle = "_hb-1";
export var commentBubble = "_hb-e";
export var commentForm = "_hb-a";
export var commentInput = "_hb-b";
export var commentLabel = "_hb-d";
export var commentPrompt = "_hb-9";
export var csatCard = "_hb-0";
export var feedbackSection = "_hb-7";
export var starDisabled = "_hb-6";
export var starEmpty = "_hb-5";
export var starFilled = "_hb-4";
export var starWrapper = "_hb-3";
export var starsContainer = "_hb-2";
export var submittedComment = "_hb-c";
export var thankYouText = "_hb-8";